import React from 'react';

const GradeComplete = ({ confidenceScore }) => {
  const pct = Math.round((confidenceScore || 0) * 100);

  const color = pct >= 71 ? '#00C853' : pct >= 51 ? '#00E676' : '#546E7A';
  const label = pct >= 71 ? 'Well Graded' : pct >= 51 ? 'Partially Graded' : 'Needs Grading';

  return (
    <div className="panel-card fade-in delay-400 flex flex-col items-center justify-center text-center">
      <div className="flex items-center gap-2 mb-6 self-start">
        <div className="w-1 h-6 bg-[#00D4FF] rounded"></div>
        <h2 className="text-white font-bold text-base">Grade Completion</h2>
      </div>

      {/* Big percentage */}
      <div
        className="font-rajdhani font-bold leading-none mb-3"
        style={{ fontSize: '5rem', color }}
      >
        {pct}%
      </div>

      {/* Label */}
      <div
        className="text-sm font-semibold tracking-wider uppercase mb-6"
        style={{ color }}
      >
        {label}
      </div>

      {/* Progress bar */}
      <div className="w-full h-2 bg-[#243B55] rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-1000"
          style={{ width: `${pct}%`, backgroundColor: color }}
        />
      </div>

      <div className="text-[#546E7A] text-xs mt-3">
        {pct < 100 ? `${100 - pct}% of criteria still ungraded` : 'All criteria graded'}
      </div>
    </div>
  );
};

export default GradeComplete;
